import { Component, OnInit } from '@angular/core';
import { RxComposite } from '../model/rx-composite';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'rx-img-composite',
  templateUrl: './rx-img-composite.component.html',
  styleUrls: ['./rx-img-composite.component.scss'],
})
export class RxImgCompositeComponent extends RxComposite implements OnInit {
  constructor(public dialogRef: MatDialogRef<any>) {
    super();
  }

  ngOnInit() {
    console.log('RxImgCompositeComponent', this.payload);
  }

  close() {
    this.payload.imgError = true;
    this.dialogRef.close();
  }
}
